import { ReactNode } from 'react';
import cn from 'classnames';
// Ui
import Text from 'ui3/Text/Text';
// Styles
import styles from './StreamOptionRow.module.scss';

export const FAN_ENGAGEMENT_OPTIONS = {
  fanPollingEnabled: {
    title: 'Fan Polling',
    description: 'Let fans vote on who they think will win each matchup.',
  },
  sharePickGraphicsEnabled: {
    title: 'Share Pick Graphics',
    description:
      'Auto-generate social media graphics when fans share their picks.',
  },
} as const;

export type StreamOptionRowsProps = {
  children: ReactNode;
};

export const StreamOptionRows = ({ children }: StreamOptionRowsProps) => (
  <div className={styles.options}>{children}</div>
);

export type StreamOptionRowProps = {
  title: string;
  description: string;
  children: ReactNode;
  /** Dims the row; a disabled switch alone looks the same as one that is off. */
  disabled?: boolean;
  /** Why the option is unavailable. */
  note?: string;
  className?: string;
};

const StreamOptionRow = ({
  title,
  description,
  children,
  disabled,
  note,
  className,
}: StreamOptionRowProps) => (
  <div className={cn(styles.row, { [styles.disabled]: disabled }, className)}>
    <div className={styles.copy}>
      <Text variant="body2Medium">{title}</Text>
      <Text variant="body2Regular" color="lights-low">
        {description}
      </Text>
      {note && (
        <Text variant="body3Regular" color="lights-medium">
          {note}
        </Text>
      )}
    </div>
    {children}
  </div>
);

export default StreamOptionRow;
